import React from 'react'

export const LoadingMessage: React.FC<{ message: string }> = ({ message }) => (
  <div className='modalSection m1em pb70 pt70 fadein'>
    <div className='center-text'>
      <div data-tid-loading-indicator className='spinner spinner-purple fz-24'></div>
      {message}
    </div>
  </div>
)
